import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  private filesSubject = new BehaviorSubject<{ name: string, type?: string, data?: string | ArrayBuffer, requestType?: string  }[]>([]);
  files$ = this.filesSubject.asObservable();

  addFile(file: { name: string, type: string, data: string | ArrayBuffer, requestType: string  }) {
    const currentFiles = this.filesSubject.value;
    this.filesSubject.next([...currentFiles, file]);
  }

  removeFile(index: number) {
    const currentFiles = this.filesSubject.value;
    currentFiles.splice(index, 1);
    this.filesSubject.next([...currentFiles]);
  }
  clearFiles() {
    this.filesSubject.next([]);
  }
  updateFiles(files: { name: string, type?: string, data?: string | ArrayBuffer, requestType?: string }[]) {
    this.filesSubject.next(files);
  }
}
